import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import Swal from 'sweetalert2';

@Component({
  selector: 'report-request-template',
  template: require('./report-request-template.html'),
  styles: [``]
})
export class ReportRequestTemplateComponent implements OnInit, OnDestroy {
  static parameters = [HttpClient, UtilityService]
  @Input() queueType: any;
  @Input() reportId: any = 0;
  @Input() dValue: any;

  public RequestReportList: any;
  public RequestListcolumnDefs: any;
  reportRequestTimeout: any;
  public gridReportListApi: any;
  public gridReportListColumnApi: any;
  public defaultColDef = {
    resizable: true,
  };
  public unitInfo: any;
  public rowSelectionSingle: any = 'single';

  constructor(private http: HttpClient, public utilityService: UtilityService) {
    this.http = http;
    this.utilityService = utilityService;
    this.unitInfo = JSON.parse(localStorage.getItem('permission') as any)[0];
  }

  f_chkString(p_value: any) {
    var Val = (p_value ? p_value.toString() : '').trim();
    return Val;
  }

  dowloadFile(urlList: any) {
    var a = document.createElement('a');
    a.setAttribute('href', urlList.shift());
    a.setAttribute('download', '');
    a.click();
    if (urlList.length > 0) {
      this.dowloadFile(urlList);
    }
  }

  RemoveOldIframes() {
    try {
      $(`iframe[name="IFramePdfPrint"]`).each(function () {
        $(this).remove();
      });
    } catch (ex) {}
  }

  ngOnInit(): void {
    this.RequestReportList = [];
    let self = this;
    this.RequestListcolumnDefs = [
      { headerName: 'Report Name', field: 'ReportCaption', width: 300 },
      { headerName: 'Requested', field: 'RequestedAt', width: 100 },
      { headerName: 'Completed', field: 'CompletedAt', width: 100 },
      { headerName: 'Status', field: 'Status', width: 100 },
      {
        headerName: 'Action',
        field: 'Action',
        width: 140,
        cellStyle: {
          'justify-content': 'center',
          'align-items': 'center',
          display: 'flex',
        },
        cellRenderer: function (params: any) {
          if (!params.data.ReporPath) {
            return;
          }
          const ReporPathList = params.data.ReporPath.split(',');
          let div = document.createElement('div');
          div.id = params.data.ID;
          let pathlist = ReporPathList[0].toLocaleLowerCase().split('.');
          if (['xlsx', 'xls', 'csv'].includes(pathlist[pathlist.length - 1])) {
            let excels = document.createElement('i');
            excels.className = 'fa fa-file-excel-o';
            excels.style.fontSize = 'x-large';
            excels.style.color = 'green';
            let input = document.createElement('a');
            input.addEventListener('click', function (e) {
              self.dowloadFile(ReporPathList);
            });
            input.type = 'button';
            input.id = 'excels';
            input.appendChild(excels);
            input.title = 'download';
            div.appendChild(input);
          } else {
            let pdfi = document.createElement('i');
            pdfi.className = 'fa fa-file-pdf-o';
            pdfi.style.fontSize = 'x-large';
            pdfi.style.color = 'darkred';

            let pdfprint = document.createElement('i');
            pdfprint.className = 'fa fa-print';
            pdfprint.style.fontSize = 'x-large';
            pdfprint.style.color = '#3884c1';

            let pdfInfo = document.createElement('i');
            pdfInfo.className = 'fa fa-eye';
            pdfInfo.style.fontSize = 'x-large';
            pdfInfo.style.color = 'grey';

            let inputInfo = document.createElement('a');
            inputInfo.addEventListener('click', () => {
              window.open(ReporPathList[0], '_blank');
            });
            inputInfo.type = 'button';
            inputInfo.id = 'pdf';
            inputInfo.appendChild(pdfInfo);
            inputInfo.title = 'preview';

            let input = document.createElement('a');
            input.download = '';
            input.href = ReporPathList[0];
            input.type = 'button';
            input.id = 'pdf';
            input.style.marginLeft = '20px';
            input.appendChild(pdfi);
            input.title = 'download';

            let input1 = document.createElement('a');
            input1.type = 'button';
            input1.id = 'print';
            input1.style.marginLeft = '20px';
            input1.title = 'print';
            input1.addEventListener('click', function () {
              self.RemoveOldIframes();
              $('<iframe>', {
                name: 'IFramePdfPrint',
                class: 'printFrame',
                src: ReporPathList[0],
                style: 'display:none',
              }).appendTo('body');
              (window.frames as any)['IFramePdfPrint'].focus();
              (window.frames as any)['IFramePdfPrint'].print();
            });
            input1.appendChild(pdfprint);
            div.appendChild(inputInfo);
            div.appendChild(input);
            div.appendChild(input1);
          }
          return div;
        },
      },
      {
        headerName: 'Q',
        field: 'queueId',
        width: 20,
      },
      {
        headerName: 'ETime',
        field: 'ExecutionTime',
        width: 60,
      },
      {
        headerName: 'EMsg',
        field: 'ErrorMsg',
        cellRenderer: (params: any) => {
          return `<span title="${this.f_chkString(
            params.value
          ).toUpperCase()}"> ${params.value ? params.value : ''} </span>`;
        },
      },
    ];

    $(document).ready(function () {
      setTimeout(() => {
        var header = $(
          'app-report-request-template .modal-header'
        ).height() as any;
        var body = $('app-report-request-template').parent().height() as any;
        var appHeight = body - header - 15 + 'px !important';
        $(
          'app-report-request-template .modal-body .requested-report-list'
        ).attr('style', 'height:' + appHeight);
      }, 200);
    });
    this.RequestReportList = [];
    this.GetRequestedReportDetails();
    this.reportRequestTimeout = setInterval(() => {
      this.GetRequestedReportDetails();
    }, 5000); // 5 Second
  }

  ngOnDestroy() {
    clearTimeout(this.reportRequestTimeout);
  }

  onReportListGridReady(params: { api: any; columnApi: any }) {
    this.gridReportListApi = params.api;
    this.gridReportListColumnApi = params.columnApi;
  }

  toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
  });

  toastWarningMsg(options: any) {
    this.toast({
      type: 'warning',
      title: options,
      timer: 3000,
    });
  }

  GetRequestedReportDetails() {
    this.http
      .get(
        `/api/CommonReports/GetRequestedReportDetails/${this.unitInfo._id}/${this.reportId}`
      )
      .subscribe(
        (result: any) => {
          if (this.RequestReportList.length == 0) {
            this.RequestReportList = result;
          } else {
            const listMapID = this.RequestReportList.map(
              (item: any) => item.ID
            );
            result.forEach((element: any) => {
              const index = listMapID.indexOf(element.ID);
              if (index < 0) {
                this.RequestReportList.unshift(element);
                this.gridReportListApi.updateRowData({
                  add: [element],
                  addIndex: 0,
                });
              } else if (
                index >= 0 &&
                this.RequestReportList[index].Status !== element.Status
              ) {
                this.RequestReportList[index].CompletedAt = element.CompletedAt;
                this.RequestReportList[index].Status = element.Status;
                this.RequestReportList[index].ErrorMsg = element.ErrorMsg;
                this.RequestReportList[index].ReporPath = element.ReporPath;
                this.RequestReportList[index].ExecutionTime =
                  element.ExecutionTime;
                this.gridReportListApi.updateRowData({
                  update: [this.RequestReportList[index]],
                });
              }
            });
            const params = {
              force: true,
              suppressFlash: true,
            };
            this.gridReportListApi.refreshCells(params);
          }
        },
        err => {
          this.toastWarningMsg(err.error);
        }
      );
  }
}
